import { Box } from '@mui/material';
import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';

import { MoreMenuPopover } from 'src/components/MoreMenu/MoreMenuPopover';
import { usePopover } from 'src/hooks/usePopover';

import type { EditorDropDownItemProps, EditorToolbarItemProps } from '../../types';
import DataObject from '@mui/icons-material/DataObject';

const ItemRoot = styled(ButtonBase, {
  shouldForwardProp: (prop: string) => !['active', 'disabled', 'sx'].includes(prop),
})<Pick<EditorToolbarItemProps, 'active' | 'disabled'>>(({ theme }) => ({
  ...theme.typography.body2,
  width: 145,
  height: 28,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: theme.spacing(0, 0.75),
  borderRadius: +theme.shape.borderRadius * 0.75,
  border: `solid 1px ${theme.vars.palette.grey[200]}`,
  '&:hover': {
    backgroundColor: theme.vars.palette.action.hover,
  },
  variants: [
    {
      props: { active: true },
      style: {
        backgroundColor: theme.vars.palette.action.selected,
        border: `solid 1px ${theme.vars.palette.action.hover}`,
      },
    },
    {
      props: { disabled: true },
      style: {
        opacity: 0.48,
        pointerEvents: 'none',
        cursor: 'not-allowed',
      },
    },
  ],
}));

export function DropDownItem({ label, variables, onAction }: EditorDropDownItemProps) {
  const { anchorEl, open, onClose, onOpen } = usePopover();

  const actions = variables.map((variable) => ({ title: variable.label, onClick: () => onAction(variable.value) }));
  return (
    <>
      <ItemRoot onClick={onOpen}>
        <Box sx={{ mr: 1, mt: '6px' }}>
          <DataObject sx={{ fontSize: '16px' }}  />
        </Box>
        {label && label}
      </ItemRoot>
      <MoreMenuPopover actions={actions} open={open} handleClose={onClose} anchorEl={anchorEl} />
    </>
  );
}
